import React, { type ReactNode } from 'react';
import Link from '@atlaskit/link';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import type { ApplicationLinkV3Status } from '../../../../../common/entities.tsx';
import messages from '../../messages.tsx';

const InsufficientRemotePermissionDescription = (props: { context: ApplicationLinkV3Status }) => {
	const { formatMessage } = useIntl();

	if (props.context.localAuthentication?.outgoing.twoLoImpersonationEnabled) {
		return (
			<Stack space="space.100">
				<Text>
					{formatMessage(messages.insufficientRemotePermission2LOiNonfinal, {
						applicationName: props.context.link.name,
					})}
				</Text>
				<Text>
					{formatMessage(messages.insufficientRemotePermission2LOiExtNonfinal, {
						applicationName: props.context.link.name,
						link: (chunks: ReactNode[]) => (
							<Link href={props.context.link.displayUrl} target="_blank">
								{chunks}
							</Link>
						),
					})}
				</Text>
			</Stack>
		);
	}

	return (
		<Stack space="space.100">
			<Text>
				{formatMessage(messages.insufficientRemotePermission3LoNonfinal, {
					applicationName: props.context.link.name,
				})}
			</Text>
			<Text>
				{formatMessage(messages.insufficientRemotePermission3LoExtNonfinal, {
					applicationName: props.context.link.name,
					link: (chunks: ReactNode[]) => (
						<Link href={props.context.link.displayUrl} target="_blank">
							{chunks}
						</Link>
					),
					link2: (chunks: ReactNode[]) =>
						props.context.error?.authorisationUri ? (
							<Link href={props.context.error.authorisationUri} target="_blank">
								{chunks}
							</Link>
						) : (
							<Text>{chunks}</Text>
						),
				})}
			</Text>
		</Stack>
	);
};

export default InsufficientRemotePermissionDescription;
